// themeStyles.ts
import { ITheme, useTheme } from '@fluentui/react';
export interface IContainerStyle {
  backgroundColor: string;
  height: string;
  color: string;
  border: string;
  borderRadius: number;
  marginBottom: number;
}
// Función que genera estilos reutilizables basados en el tema
export const useContainerStyle = (): IContainerStyle => {
  const theme: ITheme = useTheme();

  return {
    backgroundColor: theme.palette.neutralLighterAlt,
    height: '100%',
    color: theme.palette.neutralPrimary, // Color del texto
    border: '1px solid ' + theme.palette.neutralQuaternary,
    borderRadius: 2,
    marginBottom: 5,
  };
};

export const useBackgroundStyle = () => {
  const theme: ITheme = useTheme();

  return {
    backgroundColor: theme.palette.white,
    height: '100%',
    color: theme.palette.neutralPrimary, // Color del texto
  };
};
